/**
 * useCloudSync — re-read localStorage when a realtime cloud update lands.
 *
 * Pair this with the existing `useEffect` that already does the initial
 * localStorage read. Pass that same loader callback in here and we'll call
 * it again whenever RealtimeService fires `maidly:cloud-data-updated`.
 *
 *   useCloudSync(() => {
 *     const fresh = JSON.parse(localStorage.getItem('maidly_employees') || '[]');
 *     setEmployees(fresh);
 *   });
 *
 * If you only care about specific data_types (e.g. employees+timeEntries),
 * pass the list as `types` — we'll skip unrelated bursts.
 */
import { useEffect } from 'react';

export default function useCloudSync(reloadFn, types = null) {
  useEffect(() => {
    if (typeof reloadFn !== 'function') return undefined;

    const handler = (evt) => {
      if (types && Array.isArray(types) && types.length) {
        const incoming = evt?.detail?.data_types || [];
        const overlap = incoming.some((t) => types.includes(t));
        if (!overlap) return;
      }
      try {
        reloadFn(evt);
      } catch {
        /* ignore per-page errors so the bus stays healthy */
      }
    };

    window.addEventListener('maidly:cloud-data-updated', handler);
    return () => window.removeEventListener('maidly:cloud-data-updated', handler);
  }, [reloadFn, types]);
}
